var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellPrism16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1a1 1 0 01.995 1.1A4.998 4.998 0 0113 7v2.25c0 .138.112.25.25.25a1.75 1.75 0 010 3.5H10a2 2 0 11-4 0H2.75a1.75 1.75 0 010-3.5.25.25 0 00.25-.25V7c0-2.42 1.72-4.44 4.005-4.901L7 2a1 1 0 011-1zm0 2.5A3.5 3.5 0 004.5 7v2.25A1.75 1.75 0 012.75 11a.25.25 0 100 .5h10.5a.25.25 0 100-.5 1.75 1.75 0 01-1.75-1.75V7A3.5 3.5 0 008 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.75A4.25 4.25 0 0112.25 7v2.25a1 1 0 001 1 1 1 0 010 2H2.75a1 1 0 010-2 1 1 0 001-1V7A4.25 4.25 0 018 2.75z",
    fillOpacity: 0.15
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellPrism16);
export default __webpack_public_path__ + "static/media/bell-prism-16.88684343.svg";
export { ForwardRef as ReactComponent };